import React from 'react';
import Icon from '../../../components/AppIcon';


const EditorToolbar = ({ onFormat, activeFormats = [] }) => {
  const toolbarGroups = [
    {
      name: 'text',
      tools: [
        { id: 'bold', icon: 'Bold', label: 'Bold' },
        { id: 'italic', icon: 'Italic', label: 'Italic' },
        { id: 'underline', icon: 'Underline', label: 'Underline' },
        { id: 'strikethrough', icon: 'Strikethrough', label: 'Strikethrough' }
      ]
    },
    {
      name: 'headings',
      tools: [
        { id: 'h1', icon: 'Heading1', label: 'Heading 1' },
        { id: 'h2', icon: 'Heading2', label: 'Heading 2' },
        { id: 'h3', icon: 'Heading3', label: 'Heading 3' }
      ]
    },
    {
      name: 'lists',
      tools: [
        { id: 'bulletList', icon: 'List', label: 'Bullet List' },
        { id: 'numberedList', icon: 'ListOrdered', label: 'Numbered List' }
      ]
    },
    {
      name: 'insert',
      tools: [
        { id: 'link', icon: 'Link', label: 'Insert Link' },
        { id: 'image', icon: 'Image', label: 'Insert Image' },
        { id: 'code', icon: 'Code', label: 'Code Block' },
        { id: 'quote', icon: 'Quote', label: 'Quote' }
      ]
    },
    {
      name: 'alignment',
      tools: [
        { id: 'alignLeft', icon: 'AlignLeft', label: 'Align Left' },
        { id: 'alignCenter', icon: 'AlignCenter', label: 'Align Center' },
        { id: 'alignRight', icon: 'AlignRight', label: 'Align Right' }
      ]
    }
  ];

  const isActive = (toolId) => activeFormats?.includes(toolId);

  return (
    <div className="bg-card border border-border rounded-lg p-2 md:p-3 mb-4 md:mb-6">
      <div className="flex flex-wrap items-center gap-2 md:gap-3">
        {toolbarGroups?.map((group, groupIndex) => (
          <React.Fragment key={group?.name}>
            {groupIndex > 0 && (
              <div className="hidden md:block w-px h-6 bg-border" />
            )}
            <div className="flex items-center gap-1 md:gap-2">
              {group?.tools?.map((tool) => (
                <button
                  key={tool?.id}
                  onClick={() => onFormat(tool?.id)}
                  className={`p-2 md:p-2.5 rounded-md transition-all duration-250 hover:bg-muted ${
                    isActive(tool?.id)
                      ? 'bg-primary/10 text-primary' :'text-muted-foreground hover:text-foreground'
                  }`}
                  title={tool?.label}
                  aria-label={tool?.label}
                >
                  <Icon name={tool?.icon} size={18} color="currentColor" />
                </button>
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default EditorToolbar;